import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import withTheme from "@mui/styles/withTheme";
import UpdatePassword from "../../components/UpdatePassword/UpdatePassword";
import { useDispatch, useSelector } from "react-redux";
import { fetchPublicData } from "../../redux/actions/publicActions";
import { fetchSettings } from "../../redux/actions/learningCenterSettingsActions";
import learningCenterTheme from "../../theme/learningCenterTheme";

const UpdatePasswordContainer = ({ theme }) => {
  const dispatch = useDispatch();

  const { logoImage, customColor, secondaryColor } = useSelector(
    state => state.learningCenterSettingsState
  );
  const version = useSelector(state => state.publicState.publicData.version);

  useEffect(() => {
    if (!version) {
      dispatch(fetchPublicData());
    }
    if (!logoImage) {
      dispatch(fetchSettings());
    }
  }, []);

  const handleChangePassword = ({ password }) => {
    //TODO: wire-up backend to save new password
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider
        theme={learningCenterTheme(theme, customColor, secondaryColor)}
      >
        <UpdatePassword
          onChangePassword={handleChangePassword}
          version={version}
          logo={logoImage}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default withTheme(UpdatePasswordContainer);

UpdatePasswordContainer.propTypes = {
  packages: PropTypes.any,
  values: PropTypes.any
};
